module.exports = __webpack_public_path__ + "img/3.41439a5c.png";